import type { AppEnvType } from '../app-env';

export interface IS3BucketVars {
  bucketName: string;
  publicUrl: string;
}

export interface IS3Vars {
  endpoint: string;
  privateBucket: IS3BucketVars;
  publicBucket: IS3BucketVars;
}

const r2Endpoint = 'https://8392a13dc648cd495317eb043ba00baf.r2.cloudflarestorage.com';

export const s3Vars: Record<AppEnvType, IS3Vars> = {
  local: {
    endpoint: r2Endpoint,
    privateBucket: {
      bucketName: 'myapp-private-local',
      publicUrl: 'https://private-local.s3.dev',
    },
    publicBucket: {
      bucketName: 'coolmate-media-local',
      publicUrl: 'https://media-local.yocoolmate.com',
    },
  },
  dev: {
    endpoint: r2Endpoint,
    privateBucket: {
      bucketName: 'myapp-private-dev',
      publicUrl: 'https://private-dev.s3.dev',
    },
    publicBucket: {
      bucketName: 'coolmate-media-local',
      publicUrl: 'https://media-local.yocoolmate.com',
    },
  },
  stg: {
    endpoint: r2Endpoint,
    privateBucket: {
      bucketName: 'myapp-private-stg',
      publicUrl: 'https://private-stg.s3.dev',
    },
    publicBucket: {
      bucketName: 'coolmate-media-staging',
      publicUrl: 'https://media-stg.yocoolmate.com',
    },
  },
  prod: {
    endpoint: r2Endpoint,
    privateBucket: {
      bucketName: 'myapp-private',
      publicUrl: 'https://private.s3.dev',
    },
    publicBucket: {
      bucketName: 'coolmate-media',
      publicUrl: 'https://media.yocoolmate.com',
    },
  },
};
